import { render, staticRenderFns } from "./PopupItemListToAdd.vue?vue&type=template&id=5b85c150"
import script from "./PopupItemListToAdd.vue?vue&type=script&lang=js"
export * from "./PopupItemListToAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports